import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card__head d-flex align-items-center" }
const _hoisted_2 = { class: "d-flex align-items-center text-uppercase mb-0" }
const _hoisted_3 = { class: "bt-icon bt-icon--m" }
const _hoisted_4 = { class: "ml-2" }
const _hoisted_5 = { class: "d-flex align-items-center ml-auto" }
const _hoisted_6 = {
  key: 0,
  class: "d-inline-flex align-items-center fs-18 mb-0 mr-3"
}
const _hoisted_7 = { class: "bt-icon bt-icon--s ml-2 text-warning" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, _mergeProps(_ctx.$attrs, { class: "card--primary" }), {
    content: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("h4", _hoisted_2, [
          _createVNode("span", _hoisted_3, [
            _createVNode(_component_InlineSvgScoped, {
              src: require(`@/assets/images/${_ctx.getDeviceIconFromType(_ctx.device.type)}.svg`),
              "aria-label": "icon-blueprint"
            }, null, 8, ["src"])
          ]),
          _createVNode("span", _hoisted_4, _toDisplayString(_ctx.getDeviceName()), 1)
        ]),
        _createVNode("div", _hoisted_5, [
          (!_ctx.device.isConfigured)
            ? (_openBlock(), _createBlock("p", _hoisted_6, [
                _createVNode("span", null, _toDisplayString(_ctx.$t("AppResource.ConfigurationToEnd")), 1),
                _createVNode("span", _hoisted_7, [
                  _createVNode(_component_InlineSvgScoped, {
                    src: 
                                        require('@/assets/images/icons/icon-alert-hight-full.svg')
                                    ,
                    "aria-label": "icon-alert-hight-full"
                  }, null, 8, ["src"])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 16))
}